<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="subject-end">
      <div class="bg-content"></div>
      <div class="dialog-content">
        <p class="title">温馨提示</p>
        <div class="content-body">
          <h2>考试已经结束，请您离开考场！</h2>
          <span class="orange" v-if="isHaveSubjective">试卷含有主观题，您需要根据解析手动评分（不评分以0分计算可能影响到总成绩）</span>
          <span class="orange" v-else></span>
          <div class="option">
            <a href="javascript:void(0)"
              class="look-score"
              v-if="isHaveSubjective"
              @click="subjectiveQuestionsStore">给主观题打分</a>
            <a href="javascript:void(0)"
              class="closeReal"
              v-if="!isHaveSubjective"
              @click="closeDialog">关闭</a>
            <a href="javascript:void(0)"
              class="close"
              @click="viewResults">直接查看成绩</a>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'subjectEnd',
  props: {
    visible: { type: Boolean },
    isHaveSubjective: { type: Boolean },
    activity: { type: String },
    query: { type: String },
    subFlag: { type: Boolean}
  },
  methods: {
    closeDialog(){
      if(this.$route.query.flag === 'ordinary'){
        window.location.href="about:blank"
        window.close()
        return
      }
      this.$emit('update:visible', false)
      this.$router.push({name: 'examSystem', query: {siteCourseID:this.siteCourseID, courseID:this.courseID}})
    },
    subjectiveQuestionsStore () {
      this.$emit('subjectiveQuestionsStore')
    },
    viewResults() {
      this.$emit('viewResults')
    }
  },
  mounted(){
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
  }
}
</script>
